/* EMA Search Stars — injects star ratings into predictive search results */
(function () {
  'use strict';

  var API_BASE = 'https://ema-chatbot-api-production.up.railway.app';
  var _cache   = {};   // handle → { count, average } | null

  // ── SVG stars ───────────────────────────────────────────────────────────────

  function starSvgs(avg, size) {
    var full  = Math.floor(avg);
    var half  = (avg - full) >= 0.5 ? 1 : 0;
    var empty = 5 - full - half;
    var o     = '';
    var s     = size || 12;
    var f     = '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="#f59e0b" stroke="#f59e0b" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    var e     = '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" stroke="#f59e0b" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>';
    for (var i = 0; i < full;  i++) o += f;
    if (half) o += f; // treat half as full for simplicity at 12px
    for (var j = 0; j < empty - (half ? 1 : 0); j++) o += e;
    return o;
  }

  // ── Inject stars into visible search result items ────────────────────────────

  function injectStars(container) {
    var items = (container || document).querySelectorAll('[data-ema-handle]:not([data-ema-stars-done])');
    if (!items.length) return;

    // Mark immediately — before any async work — so concurrent calls skip these elements
    items.forEach(function (li) { li.setAttribute('data-ema-stars-done', '1'); });

    var handles = [];
    items.forEach(function (li) {
      var h = li.getAttribute('data-ema-handle');
      if (h && handles.indexOf(h) === -1) handles.push(h);
    });

    // Split into cached vs needs-fetch
    var toFetch = handles.filter(function (h) { return !(h in _cache); });

    function applyStars() {
      items.forEach(function (li) {
        var h    = li.getAttribute('data-ema-handle');
        var data = _cache[h];
        if (!data) return; // no reviews — leave clean

        var avg   = parseFloat(data.average) || 0;
        var cnt   = data.count || 0;
        var label = cnt === 1 ? '(1)' : '(' + cnt + ')';

        var wrap = document.createElement('div');
        wrap.className   = 'ema-sr-stars';
        wrap.style.cssText = 'display:inline-flex;align-items:center;gap:3px;margin-top:3px;';
        wrap.innerHTML =
          '<span style="display:inline-flex;gap:1px;">' + starSvgs(avg, 12) + '</span>' +
          '<span style="font-size:0.76rem;color:#6b7280;">' + label + '</span>';

        var info = li.querySelector('.predictive-result__info');
        if (info) info.appendChild(wrap);
      });
    }

    if (!toFetch.length) {
      applyStars();
      return;
    }

    fetch(API_BASE + '/api/reviews/ratings?handles=' + toFetch.map(encodeURIComponent).join(','))
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (data) {
        toFetch.forEach(function (h) { _cache[h] = data[h] || null; });
        applyStars();
      })
      .catch(function () {
        toFetch.forEach(function (h) { _cache[h] = null; });
        applyStars();
      });
  }

  // ── Observe DOM for search result panels ─────────────────────────────────────

  function observe() {
    var mo = new MutationObserver(function (mutations) {
      var needsCheck = false;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) { needsCheck = true; break; }
        }
        if (needsCheck) break;
      }
      if (needsCheck) {
        // Small delay so Shopify finishes rendering the full panel
        setTimeout(function () { injectStars(document); }, 50);
      }
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  function start() {
    injectStars(document); // scan whatever's already in the DOM
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
